const action = {};

action.handleRequestEmployerChange = payload => ({
  type: "HANDLE_REQUEST_EMPLOYER_CHANGE",
  payload
});

export default action;
